function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => removeItem(data_line));
    });
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
        const mobileNav = document.querySelector('.mobile-nav.first-mobile-nav');
        if (mobileNav) {
          mobileNav.classList.remove('active');
          mobileNav.querySelectorAll('li.active').forEach(function(li) {
            li.classList.remove('active');
          });
        }
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter','phone-size-filter');
      });
    });
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      if(cart_count>0){
      	document.querySelector('.cart-count').innerHTML = cart_count;
      }else{
      	document.querySelector('.cart-count').innerHTML = '';
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });

  setTimeout(function() {
    initCustomSwiper();
    cycleMessages();
    autoRemoveFreeProductIfUnderLimit();
  }, 1000);

}
load_cart();



// function autoRemoveFreeProductIfUnderLimit() {
//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {
//       const FREE_PRODUCT_LIMIT = window.themeSettings?.freeProductAmount || 10000;
//       console.log('FREE_PRODUCT_LIMIT',FREE_PRODUCT_LIMIT);
//       console.log('cart.total_price',cart.total_price)
//       if (cart.total_price < FREE_PRODUCT_LIMIT * 100) {
//         const removeBtn = document.querySelector('.free-product-grid .item-remove');
//         if (removeBtn) {
//           alert('clickkkk')
//           removeBtn.click();
//         }
//       }
//     })
//     .catch(error => {
//       console.error('Error fetching cart:', error);
//     });
// }
function autoRemoveFreeProductIfUnderLimit() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Limit in GBP (example: 100)
      const FREE_PRODUCT_LIMIT = window.themeSettings?.freeProductAmount || 100;

      // console.log('FREE_PRODUCT_LIMIT (GBP)', FREE_PRODUCT_LIMIT);
      // console.log('Cart total (cents)', cart.total_price);
      // console.log('Cart total (GBP)', cart.total_price / 100);

      // Convert limit to cents for comparison
      if (cart.total_price < FREE_PRODUCT_LIMIT * 100) {
        const removeBtn = document.querySelector('.free-product-grid .item-remove');
        if (removeBtn) {
          removeBtn.click();
        }
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}




function initCustomSwiper() {
    new Swiper(".cu-slider.swiper", {
      slidesPerView: "auto",
      navigation: {
      nextEl: ".cu-slider .swiper-button-next",
      prevEl: ".cu-slider .swiper-button-prev",
    },
  });
}
setTimeout(function() {
   window.addEventListener('load', initCustomSwiper);
}, 1000);


function cycleMessages() {
  const messages = document.querySelectorAll('.main-usp .usp');
  if (messages.length === 0) return;
  let current = 0;
  function showNextMessage() {
    messages[current].classList.remove('active');
    setTimeout(() => {
      current = (current + 1) % messages.length;
      messages[current].classList.add('active');
    }, 700);
  }
  setInterval(showNextMessage, 2500);
}
setTimeout(function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cycleMessages);
  } else {
    cycleMessages();
  }
}, 1000);



document.addEventListener('click', function (e) {
  const button = e.target.closest('.item-var .sel-var');
  const itemVarBox = document.querySelector('.item-var-box');
  if (button) {
    const itemVar = button.closest('.item-var');
    if (itemVar) {
      document.querySelectorAll('.item-var.active').forEach(function (el) {
        if (el !== itemVar) {
          el.classList.remove('active');
        }
      });
      itemVar.classList.toggle('active');
    }
  } else if (!itemVarBox || !itemVarBox.contains(e.target)) {
    document.querySelectorAll('.item-var.active').forEach(function (el) {
      el.classList.remove('active');
    });
  }
});
document.addEventListener('click', function (e) {
  const button = e.target.closest('.item-var-box .var');
  if (button) {
    const parentSelVar = button.closest('.item-var');
    if (parentSelVar) {
      parentSelVar.classList.remove('active');
    }
  }
});




// document.addEventListener('click', function (e) {
//   const button = e.target.closest('.item-var-box .var');
//   if (button) {
//     const itemRow = button.closest('.item-row');
//     const dataLine = itemRow?.getAttribute('data-line');
//     const newVariantId = button.getAttribute('data-id');

//     if (dataLine) {
//       removeItem(dataLine, function () {
//         if (newVariantId) {
//           addItemNew(newVariantId);
//         }
//       });
//     } else if (newVariantId) {
//       addItemNew(newVariantId);
//     }
//   }
// });
// document.addEventListener('click', function (e) {
//   const addButton = e.target.closest('.free-add-to-cart .add-btn');
//   if (addButton) {
//     const line = addButton.getAttribute('data-id');
//     if (line) {
//       addItemNew(line);
//     }
//   }
// });
// document.addEventListener('click', function (e) {
//   const addButton = e.target.closest('.cat-qa .cart-qa-btn');
//   if (addButton) {
//     const line = addButton.getAttribute('data-id');
//     if (line) {
//       addItemNew(line);
//     }
//   }
// });
// function removeItem(data_line, callback) {
//   const data = {
//     line: data_line,
//     quantity: 0
//   };

//   fetch('/cart/change.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(data),
//   })
//     .then((response) => response.json())
//     .then((data) => {
//       if (typeof callback === 'function') {
//         callback();
//       }
//       load_cart();
//     })
//     .catch((error) => {
//       console.error('Remove Error:', error);
//     });
// }
// function addItemNew(line) {
//   const data = {
//     items: [{
//       id: line,
//       quantity: 1
//     }]
//   };

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(data),
//   })
//     .then((response) => response.json())
//     .then((data) => {
//       load_cart();
//     })
//     .catch((error) => {
//       console.error('Add Error:', error);
//     });
// }


document.addEventListener('click', function (e) {
  const button = e.target.closest('.item-var-box .var');
  if (button) {
    const itemRow = button.closest('.item-row');
    const dataLine = itemRow?.getAttribute('data-line');
    const newVariantId = button.getAttribute('data-id');

    if (dataLine && newVariantId) {
      // remove old & add new immediately
      switchVariant(dataLine, newVariantId);
    } else if (newVariantId) {
      addItemNew(newVariantId);
    }
  }
});

document.addEventListener('click', function (e) {
  const addButton = e.target.closest('.free-add-to-cart .add-btn');
  if (addButton) {
    const line = addButton.getAttribute('data-id');
    if (line) {
      addItemNew(line);
    }
  }
});

document.addEventListener('click', function (e) {
  const addButton = e.target.closest('.cat-qa .cart-qa-btn');
  if (addButton) {
    const line = addButton.getAttribute('data-id');
    if (line) {
      addItemNew(line);
    }
  }
});

// ---- helpers ---- //

function switchVariant(dataLine, newVariantId) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: dataLine,
      quantity: 0
    }),
  })
    .then((res) => res.json())
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: newVariantId, quantity: 1 }]
        }),
      });
    })
    .then((res) => res.json())
    .then(() => {
      load_cart();
    })
    .catch((err) => {
      console.error('Switch Error:', err);
    });
}

function addItemNew(line) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{ id: line, quantity: 1 }]
    }),
  })
    .then((res) => res.json())
    .then(() => {
      load_cart();
    })
    .catch((err) => {
      console.error('Add Error:', err);
    });
}






// Handle click on ".item_plus"
document.addEventListener('click', function (e) {
  const plusBtn = e.target.closest('.item_plus');
  if (plusBtn) {
    const centerQty = plusBtn.previousElementSibling;
    const input = centerQty.querySelector('input');
    input.value = +input.value + 1;

    const newLine = plusBtn.getAttribute('data-line-item');
    const newQty = plusBtn.closest('.main_qty').querySelector('input.cart_qty').value;
    addItem(newLine, newQty);
  }
});

// Handle click on ".item_minus"
document.addEventListener('click', function (e) {
  const minusBtn = e.target.closest('.item_minus');
  if (minusBtn) {
    const centerQty = minusBtn.nextElementSibling;
    const input = centerQty.querySelector('input');
    if (+input.value > 0) {
      input.value = +input.value - 1;
    }

    const newLine = minusBtn.getAttribute('data-line-item');
    const newQty = minusBtn.closest('.main_qty').querySelector('input.cart_qty').value;
    addItem(newLine, newQty);
  }
});

// Handle change on quantity input
document.addEventListener('change', function (e) {
  const input = e.target.closest('.center_qty .cart_qty');
  if (input) {
    const newQty = input.value;
    const centerQty = input.closest('.center_qty');
    const itemMinus = centerQty.previousElementSibling;
    const line = itemMinus?.getAttribute('data-line-item');
    if (line) {
      addItem(line, newQty);
    }
  }
});

// Add/update cart item
function addItem(newLine, newQty) {
  const data = { line: newLine, quantity: newQty };

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      load_cart();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}




  // $(document).on('click', '.item_plus', function () {
  //     $(this).prev('.center_qty').find('input').val(+$(this).prev('.center_qty').find('input').val() + 1);
  //     var new_line = $(this).data('line-item')
  //     var new_qty = $(this).closest('.main_qty').find('input.cart_qty').val();
  //     addItem(new_line, new_qty);
  // });
  // $(document).on('click', '.item_minus', function () {
  //     if ($(this).next('.center_qty').find('input').val() > 0) $(this).next('.center_qty').find('input').val(+$(this).next('.center_qty').find('input').val() - 1);
  //     var new_line = $(this).data('line-item')
  //     var new_qty = $(this).closest('.main_qty').find('input.cart_qty').val();
  //     addItem(new_line, new_qty);
  // });

  //  $(document).on('change','.center_qty .cart_qty', function() {
  //   var new_qty = $(this).val();
  //     var line = $(this).parent('.center_qty').siblings('.item_minus').data('line-item')
  //   addItem(line,new_qty); 
  // });

  //   function addItem(new_line, new_qty) {
  //     const data = { 'line': new_line, 'quantity': new_qty };
  //     fetch('/cart/change.js', {
  //         method: 'POST',
  //         headers: {
  //             'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify(data),
  //     })
  //     .then((response) => response.json())
  //     .then((data) => {
  //         load_cart();
  //     })
  //     .catch((error) => {
  //         console.error('Error:', error);
  //     });
  // }



// document.addEventListener('click', function (e) {
//   const button = e.target.closest('.item-var-box .var');
//   if (button) {
//     const itemRow = button.closest('.item-row');
//     const dataLine = itemRow?.getAttribute('data-line');
//     alert(dataLine);
//     if (dataLine) {
//       removeItem(dataLine);
//     }
//   }
// });

// document.addEventListener('click', function (e) {
//   const button = e.target.closest('.item-var-box .var');
//   if (button) {
//     const line = button.getAttribute('data-id');
//     if (line) {
//       addItemNew(line);
//     }
//   }
// });


function removeItem(data_line){
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}


// document.addEventListener('click', function (e) {
//   if (e.target.closest('.free-add-to-cart .add-btn')) {
//     var button = e.target.closest('.add-btn');
//     var line = button.getAttribute('data-id');
//     addItemNew(line);
//   }
// });
// function addItemNew(line) {
//   let data = {
//     'items': [{
//       'id': line,
//       'quantity': 1
//     }]
//   };
//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(data),
//   })
//     .then((response) => response.json())
//     .then((data) => {
//       load_cart();
//     })
//     .catch((error) => {
//       console.error('Error:', error);
//     });
// }


